// villes.ts - villes actives pour le badge « En direct » et le select du formulaire.
// Lecture publique, Firestore chargé paresseusement. Ne lève jamais : en cas
// d'échec ou de résultat vide, on retombe sur ["Compiègne"].
import { COLLECTIONS, type Ville } from "@hop-resto/shared";
import { getDb } from "./firebase";

/** Ville affichée par défaut quand aucune ville active n'a pu être chargée. */
export const FALLBACK_CITY = "Compiègne";

/** Premier mot du nom, ex. "Compiègne et environs" -> "Compiègne". */
function shortName(nom: string): string {
  return nom.split(" ")[0] ?? nom;
}

/** Noms courts de toutes les villes actives. Ne rejette jamais. */
export async function fetchActiveCityNames(): Promise<string[]> {
  try {
    const [{ collection, getDocs, query, where }, db] = await Promise.all([
      import("firebase/firestore"),
      getDb(),
    ]);
    const q = query(collection(db, COLLECTIONS.villes), where("actif", "==", true));
    const snap = await getDocs(q);
    const names = snap.docs
      .map((d) => (d.data() as Ville).nom)
      .filter((nom): nom is string => typeof nom === "string" && nom.length > 0)
      .map(shortName);
    return names.length ? names : [FALLBACK_CITY];
  } catch (err) {
    console.error("[landing] failed to load active cities", err);
    return [FALLBACK_CITY];
  }
}
